<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-secteuractivite">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un secteur d'activité"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Libellé
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Description
              </th>
              <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th> -->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(secteur, index) in secteurs" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ secteur.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ secteur.description }}
              </td>
              <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="secteur.statut ? 'badge text-white bg-success' : 'badge text-white bg-secondary'">
                  {{ secteur.statut ? 'Actif' : 'Inactif' }}
                </span>
              </td> -->
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{ name: 'EditSecteurActivitePage', params: { id: secteur.id } }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                      </router-link>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="deleteSecteur(secteur.id)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "../../services/ApiService";
import { error } from "../../utils/utils";
import Swal from "sweetalert2";
import PaginationComponent from "../../components/Utilities/Pagination.vue";
import { SecteurActiviteRecensement } from "../../models/SecteurActiviteRecensement";

export default defineComponent({
  name: "ListeSecteurActivite",
  components: {
    PaginationComponent,
  },
  setup() {
    onMounted(() => {
      getAllSecteurs();
    });

    const secteurs = ref<Array<SecteurActiviteRecensement>>([]);

    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      page.value = page_;
      getAllSecteurs(page_, limit_);
    };

    function rechercher() {
      getAllSecteurs(page.value, limit.value, searchTerm.value);
    }

    function getAllSecteurs(page = 1, limi = 10, searchTerm = "") {
      return ApiService.get(
        `/secteuractivites?page=${page}&limit=${limi}&mot=${searchTerm}&`
      )
        .then(({ data }) => {
          secteurs.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const deleteSecteur = (id: number) => {
      Swal.fire({
        text: "Vous êtes sur le point de supprimer ce secteur d'activité. Etes-vous sûr ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        heightAuto: false,
        customClass: { confirmButton: "btn btn-danger" },
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.delete(`/secteuractivite/${id}`)
            .then(({ data }) => {
              Swal.fire({
                text: data.message,
                toast: true,
                icon: "success",
                title: "Secteur supprimé",
                position: "top-right",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                heightAuto: false,
              });
              for (let i = 0; i < secteurs.value.length; i++) {
                if (secteurs.value[i].id === id) {
                  secteurs.value.splice(i, 1);
                }
              }
            })
            .catch(({ response }) => {
              Swal.fire({
                text: response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Réessayer à nouveau!",
                heightAuto: false,
                customClass: { confirmButton: "btn fw-semobold btn-light-danger" },
              });
            });
        }
      });
    };

    return {
      secteurs,
      getAllSecteurs,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      deleteSecteur,
      rechercher,
      searchTerm,
    };
  },
});
</script>
